/* @flow */
const prefix = str => `station/settings/${str}`;

export const SET_ENCLAVE_MENU = prefix('SET_ENCLAVE_MENU');

export const SELECT_DEFAULT_ENCLAVE = prefix('SELECT_DEFAULT_ENCLAVE');

export const TIMEZONE_CHANGED = prefix('TIMEZONE_CHANGED');

export const SAVE_EMAIL_SETTINGS = prefix('SAVE_EMAIL_SETTINGS');
export const SAVE_EMAIL_SETTINGS_SUCCESS = prefix('SAVE_EMAIL_SETTINGS_SUCCESS');
export const SAVE_EMAIL_SETTINGS_FAILURE = prefix('SAVE_EMAIL_SETTINGS_FAILURE');

export const FETCH_INGEST_EMAILS = prefix('FETCH_INGEST_EMAILS');
export const FETCH_INGEST_EMAILS_SUCCESS = prefix('FETCH_INGEST_EMAILS_SUCCESS');
export const FETCH_INGEST_EMAILS_FAILURE = prefix('FETCH_INGEST_EMAILS_FAILURE');

export const CANCEL_CONFIRM_DELETE_INGEST_EMAIL = prefix('CANCEL_CONFIRM_DELETE_INGEST_EMAIL');
export const CONFIRM_DELETE_INGEST_EMAIL = prefix('CONFIRM_DELETE_INGEST_EMAIL');
export const DELETE_INGEST_EMAIL = prefix('DELETE_INGEST_EMAIL');
export const DELETE_INGEST_EMAIL_SUCCESS = prefix('DELETE_INGEST_EMAIL_SUCCESS');
export const DELETE_INGEST_EMAIL_FAILURE = prefix('DELETE_INGEST_EMAIL_FAILURE');

export const EDIT_EMAIL_INGEST = prefix('EDIT_EMAIL_INGEST');
export const CLEAR_EMAIL_INGEST = prefix('CLEAR_EMAIL_INGEST');

export const TOGGLE_SELECT_EMAIL_INGEST = prefix('TOGGLE_SELECT_EMAIL_INGEST');
export const CLEAR_SELECTED_EMAIL_INGEST = prefix('CLEAR_SELECTED_EMAIL_INGEST');

export const CREATE_NEW_EMAIL_INGEST = prefix('CREATE_NEW_EMAIL_INGEST');
export const CLOSE_NEW_EMAIL_FORM = prefix('CLOSE_NEW_EMAIL_FORM');

export const CONFIRM_REQUEST_NEW_INGEST_EMAIL = prefix('CONFIRM_REQUEST_NEW_INGEST_EMAIL');
export const CANCEL_CONFIRM_REQUEST_NEW_INGEST_EMAIL = prefix('CANCEL_CONFIRM_REQUEST_NEW_INGEST_EMAIL');


// WEBPACK FOOTER //
// ./src/app/modules/settings/action-types.js